import React from 'react';

const ActivationSuccess = () => {
  return (
    <div className="registration-main">
      <div className="registration__summary">
        <div className="registration__summary-validation">
          <div className="registration-main__head txt-c">
            <h1 className="registration-main__h1">Success!</h1>
            <h2 className="registration-main__h2">Your email address has been verified.</h2>
            <button
              className="btn-primary-s registration-form__submit"
              type="button"
              title="Continue"
              onClick={() => {
                window.location = server.links.home;
              }}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ActivationSuccess;